
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5b12"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5b12"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("aQpoM", function(module, exports) {

$parcel$export(module.exports, "basePath", () => $7e527658d2b46be6$export$3b164a006a884f7);
// configurar el basepath y el if que lo determina
const $7e527658d2b46be6$var$productionPath = "https://d3vh4n5.github.io/CaC-Fullstack-Node-Grupo10";
const $7e527658d2b46be6$export$3b164a006a884f7 = (()=>{
    if (document.location.hostname === "d3vh4n5.github.io") {
        console.warn("Creando redirecci\xf3n");
        return $7e527658d2b46be6$var$productionPath;
    } else {
        console.info("Navigation: normal");
        return "";
    }
})();

});

parcelRegister("d1as2", function(module, exports) {
module.exports = new URL("hu.e94fc771.svg", import.meta.url).toString();

});

parcelRegister("3drbU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2577ad8ffca11504$export$2e2bcd8739ae039);

var $aQpoM = parcelRequire("aQpoM");
class $2577ad8ffca11504$var$Session {
    #name;
    #email;
    #role;
    #state;
    #accessToken;
    #refreshToken;
    #isSignedIn;
    constructor(){
        try {
            const user = JSON.parse(localStorage.getItem("user"));
            this.#name = user.name;
            this.#email = user.email;
            this.#role = user.role;
            this.#state = user.state;
            this.#accessToken = localStorage.getItem("accessToken");
            this.#refreshToken = localStorage.getItem("refreshToken");
            this.#isSignedIn = true;
        } catch (error) {
            console.log("Probablemente no haya sesi\xf3n");
        }
    }
    get isSignedIn() {
        return this.#isSignedIn;
    }
    get userName() {
        return this.#name;
    }
    get accessToken() {
        return this.#accessToken;
    }
    get refreshToken() {
        return this.#refreshToken;
    }
    async destroy() {
        // solicitd de logout al back para que borre el refresh token
        localStorage.removeItem("user");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        this.#isSignedIn = false;
        document.location.href = (0, $aQpoM.basePath) + "/";
    }
    show() {
        console.table({
            Nombre: this.#name,
            email: this.#email,
            Rol: this.#role,
            Estado: this.#state,
            Token: this.#accessToken,
            RF: this.#refreshToken
        });
    }
    check() {
        const isSignedIn = localStorage.getItem("accessToken");
        if (isSignedIn === null) document.location.href = (0, $aQpoM.basePath) + "/";
    }
}
const $2577ad8ffca11504$var$session = new $2577ad8ffca11504$var$Session();
var $2577ad8ffca11504$export$2e2bcd8739ae039 = $2577ad8ffca11504$var$session;

});

var $bd7a3ee4bb719ab3$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["5e2CB","index.09307cc1.js","JnirO","hu.e94fc771.svg"]'));

const $bab2ee6bc5457f25$export$cd891b82501bb412 = [
    {
        href: "/index.html",
        label: "Inicio"
    },
    {
        href: "/pages/about.html",
        label: "Acerca de"
    },
    {
        href: "/pages/contact.html",
        label: "Contacto"
    }
];
const $bab2ee6bc5457f25$export$7b0f2c3383a05dbf = [
    {
        href: "/pages/dashboard",
        label: "Dashboard"
    }
];



var $aQpoM = parcelRequire("aQpoM");
// var isBrowser= new Function("try {return this===window;}catch(e){ return false;}");
// var isNode=new Function("try {return this===global;}catch(e){return false;}");
// export function envDetector(){
//     // tests if global scope is bound to "global"
//     if(isNode()) console.log("running under node.js");
//     // tests if global scope is bound to window
//     if(isBrowser()) console.log("running under browser");
// }
const $2b507043f9c4f9f9$export$8eb565c8c662d7e8 = (()=>{
    try {
        return "true";
    } catch (e) {
        return false;
    }
})() // var isNode = false;    
 // if (typeof process === 'object') {
 //   if (typeof process.versions === 'object') {
 //     if (typeof process.versions.node !== 'undefined') {
 //       isNode = true;
 //     }
 //   }
 // }
 // if (typeof module === "object" && typeof module.exports === "object") {
 //     // node
 // }
 // if (typeof window !== "undefined" && typeof window.document !== "undefined") {
 //     // browser
 // }
;



var $aQpoM = parcelRequire("aQpoM");

const $bfb92a82c285d30b$export$9127118863174cf1 = (()=>{
    if (0, $2b507043f9c4f9f9$export$8eb565c8c662d7e8) return (parcelRequire("d1as2"));
    else return (0, $aQpoM.basePath) + "/assets/img/hu.svg";
})();



var $3drbU = parcelRequire("3drbU");
const $f0600fff339aa136$var$headerTempalte = (basePath = "")=>{
    return `
<header class="header">
    <div class="header__container">
        <div class="header__logo-container">
            <img src="${0, $bfb92a82c285d30b$export$9127118863174cf1}" alt="Logo" class="header__logo-img">
            <!-- <h2 class="header__logo-name">LOGO</h2> -->
        </div>
        <label class="header__burger-button" for="drawer">
            <i class="fa-solid fa-bars"></i>
        </label>
        <input class="header__responsive-checkbox" type="checkbox" name="drawer" id="drawer">
        <nav class="header__nav">
            <label class="header__close-button" for="drawer">
                <!-- <i class="fa-solid fa-xmark"></i> -->
                <i class="fa-solid fa-x"></i>
            </label>
            <ul class="header__nav-list">
                ${(0, $bab2ee6bc5457f25$export$cd891b82501bb412).map((R)=>`
                  <li class="header__nav-item">
                      <a class="header__nav-link" href="${basePath + R.href}">${R.label}</a>
                  </li>
                  `).join("")}
                ${(0, $3drbU.default).isSignedIn ? (0, $bab2ee6bc5457f25$export$7b0f2c3383a05dbf).map((R)=>`
                            <li class="header__nav-item">
                                <a class="header__nav-link" href="${basePath + R.href}">${R.label}</a>
                            </li>
                            `).join("") : ""}
            </ul>
            <div class="header__login-container">
                ${(0, $3drbU.default).isSignedIn ? `
                        <a href="/pages/logout.html" class="INSIDE-NAV header__logout-btn" id="logoutBtn">
                            Cerrar Sesi\xf3n
                        </a>
                    ` : `
                        <a href="/pages/login.html" class="INSIDE-NAV header__login-btn">
                            Ingreso
                        </a>
                    `}
            </div>
        </nav>
        <label class="header__darkscreen" for="drawer"></label>
    </div>
</header>
`;
};
class $f0600fff339aa136$var$HeaderComponent extends HTMLElement {
    constructor(){
        super();
        this.innerHTML = $f0600fff339aa136$var$headerTempalte((0, $aQpoM.basePath));
    }
}
customElements.define("header-component", $f0600fff339aa136$var$HeaderComponent);




var $aQpoM = parcelRequire("aQpoM");

const $e371732a60f7e9b4$var$footerTempalte = (basePath = "")=>`
<footer class="footer">
    <section class="footer__container">
        <div class="footer__logo">
            <img src="${0, $bfb92a82c285d30b$export$9127118863174cf1}" alt="Logo" class="footer__logo-img">
        </div>
        <article class="footer__top-content">

            <nav class="footer__nav">
                <h5>Mapa de sitio</h5>
                <ul class="footer__nav-list">
                  ${(0, $bab2ee6bc5457f25$export$cd891b82501bb412).map((R)=>`
                    <li class="footer__nav-item">
                        <a class="footer__nav-link" href="${basePath + R.href}">${R.label}</a>
                    </li>
                    `).join("")}
                </ul>
                </nav>
                <div class="footer__contacts">
                    <h5>Informaci\xf3n de contacto</h5>
                    <ul class="footer__contact-list">
                        <li class="footer__contact-item"><i class="fas fa-phone"></i> 011 4321 98765</li>
                        <li class="footer__contact-item"><i class="fas fa-map-marker-alt"></i> Av Siempreviva 742</li>
                        <li class="footer__contact-item"><i class="fas fa-envelope"></i> estemailesfalso@mail.com</li>
                        <li class="footer__contact-item">
                            <i class="fas fa-envelope"></i>
                            <a class="" href="${basePath}/pages/contact.html">Dejanos un mensaje!</a>
                        </li class="footer__contact-item">
                    </ul>
                    <div>
                    </div>
                </div>
                
                <div class="footer__info">
                    <h5>Nosotros</h5>
                    <p>
                        HealthUp es un proyecto creado con motivos did\xe1cticos, no es un proyecto real y debe tener cuidado con su uso.
                    </p>
                    <p>
                        Para m\xe1s informaci\xf3n <a href="${basePath}/pages/about.html#project">haga click aqu\xed</a>
                    </p>
                </div>
    
            </article>
            
            <hr>
    
            <div class="footer__social-container">
                <ul class="footer__social-list">
                    <li class="footer__social-item"><a class="footer__social-link" href="https://github.com/d3vh4n5/CaC-Fullstack-Node-Grupo10" target="_blank" title="GitHub" rel="noopener noreferrer"><i class="fa-brands fa-square-github"></i></a></li>
                    <li class="footer__social-item"><a class="footer__social-link" href="https://github.com/d3vh4n5/CaC-Fullstack-Node-Grupo10" target="_blank" title="Instagram" rel="noopener noreferrer"><i class="fa-brands fa-square-instagram"></i></a></li>
                    <li class="footer__social-item"><a class="footer__social-link" href="https://github.com/d3vh4n5/CaC-Fullstack-Node-Grupo10" target="_blank" title="Facebook" rel="noopener noreferrer"><i class="fa-brands fa-facebook"></i></a></li>
                    <li class="footer__social-item"><a class="footer__social-link" href="https://github.com/d3vh4n5/CaC-Fullstack-Node-Grupo10" target="_blank" title="Twitter" rel="noopener noreferrer"><i class="fa-brands fa-square-x-twitter"></i></a></li>
                </ul>
            </div>
    
            <small class="footer__copyright">
                <div>
                    \xa9\u{FE0F} 2024
                    <code translate="no" class="footer__brand">
                        HealthUp Project.
                    </code>
                    Todos los derechos reservados
                </div>
                <div>
                    Desarrollado por
                    <code translate="no" class="footer__brand">
                        <a href="${basePath}/pages/about.html#devs">
                            Grupo 10 - Codo a Codo Comisi\xf3n 24126.
                        </a>
                    </code>
                </div>
            </small>
            
        </section>
    </footer>
`;
class $e371732a60f7e9b4$var$FooterComponent extends HTMLElement {
    constructor(){
        super();
        this.innerHTML = $e371732a60f7e9b4$var$footerTempalte((0, $aQpoM.basePath));
    }
}
customElements.define("footer-component", $e371732a60f7e9b4$var$FooterComponent);


const $6c6b25fc965b2664$var$devCardTemplate = ({ name: name, sex: sex, linkedin: linkedin, location: location, github: github, portfolio: portfolio, description: description })=>`
<div class="dev-card">
<header class="dev-card__header">
  <img src="../assets/img/${sex === "male" ? "man" : "woman"}.svg" class="dev-card__person-img" alt="">
  <div class="dev-card__contacts">
    <h5 class="dev-card__title">${name || "$dev name"}</h5>
    <ul class="dev-card__contacts-list">
      <li class="dev-card__contact-item">
        <i class="fa-brands fa-linkedin"></i>
        <a href="${linkedin}" target="_blank" rel="noopener noreferrer">LinkedIn</a>    
       </li>
      <li class="dev-card__contact-item"><i class="fas fa-map-marker-alt"></i>${location}</li>
      <li class="dev-card__contact-item">
        <i class="fa-brands fa-square-github"></i> 
        <a href="${github}" target="_blank" rel="noopener noreferrer">GitHub</a>    
      </li>
      ${portfolio && `
          <li class="dev-card__contact-item">
          <i class="fa-duotone fa-id-card"></i>
            <a href="${portfolio}" target="_blank" rel="noopener noreferrer">Portfolio</a>    
          </li>
      `}
    </ul>
  </div>
</header>
<main class="dev-card__body">
  <p class="dev-card__description">
    ${description}
  </p>
</main>
</div>
`;
class $6c6b25fc965b2664$var$DevCard extends HTMLElement {
    constructor(){
        super();
        const dev = {
            name: this.getAttribute("name"),
            sex: this.getAttribute("sex"),
            linkedin: this.getAttribute("linkedin"),
            location: this.getAttribute("location"),
            github: this.getAttribute("github"),
            portfolio: this.getAttribute("portfolio"),
            description: this.getAttribute("description")
        };
        this.innerHTML = $6c6b25fc965b2664$var$devCardTemplate(dev);
    }
}
customElements.define("dev-card", $6c6b25fc965b2664$var$DevCard);



var $aQpoM = parcelRequire("aQpoM");
class $1ac854de1e84b10f$var$InsideLink extends HTMLElement {
    constructor(){
        super();
        const shadow = this.attachShadow({
            mode: "open"
        });
        this.anchor = document.createElement("a");
        this.anchor.setAttribute("href", "#");
        const slot = document.createElement("slot");
        this.anchor.appendChild(slot);
        this.anchor.style.all = "unset";
        this.classList.add("inside-link");
        shadow.appendChild(this.anchor);
    }
    _handleProps() {
        const href = this.getAttribute("href");
        if (href !== null) this.anchor.setAttribute("href", href);
        else this.anchor.setAttribute("href", "#");
    }
    _handleClick() {
        this.anchor.addEventListener("click", (event)=>{
            event.preventDefault();
            // const newRoute = this.anchor.getAttribute('href');
            // history.pushState(null, '', newRoute);
            // const customEvent = new CustomEvent('historyChange', {
            //     detail: {
            //         newRoute
            //     }
            // });
            // window.dispatchEvent(customEvent)
            console.log((0, $aQpoM.basePath));
            console.log(this.anchor.getAttribute("href"));
            // event.target.click()
            window.location.href = (0, $aQpoM.basePath) + this.anchor.getAttribute("href");
        });
    }
    _handleActive() {
        const currentPath = window.location.pathname;
        const linkPath = new URL(this.anchor.href).pathname;
        if (currentPath === linkPath) this.classList.add("active");
        else this.classList.remove("active");
    }
    connectedCallback() {
        this._handleProps();
        this._handleClick();
        this._handleActive();
        window.addEventListener("historyChange", ()=>{
            this._handleActive();
        });
    }
}
window.customElements.define("inside-link", $1ac854de1e84b10f$var$InsideLink);


const $454ccda6f781c9b1$var$template = document.createElement("template");
$454ccda6f781c9b1$var$template.innerHTML = `
<style>
div{
    background-color: lightgreen;
}
</style>
    <div class="bg-danger">
        <hr>
            <slot></slot>
        <hr>
    </div>
`;
class $454ccda6f781c9b1$var$DashboardLayout extends HTMLElement {
    constructor(){
        super();
        const shadow = this.attachShadow({
            mode: "open"
        });
        shadow.appendChild($454ccda6f781c9b1$var$template.content.cloneNode(true));
    }
}
window.customElements.define("dashboard-layout", $454ccda6f781c9b1$var$DashboardLayout);


/**
 *  https://github.com/justinribeiro/lite-youtube
 * 
 */ // export class LiteYTEmbed extends HTMLElement {
class $68499d7e04db319d$var$LiteYTEmbed extends HTMLElement {
    constructor(){
        super();
        this.isIframeLoaded = false;
        this.setupDom();
    }
    static get observedAttributes() {
        return [
            "videoid",
            "playlistid"
        ];
    }
    connectedCallback() {
        this.addEventListener("pointerover", $68499d7e04db319d$var$LiteYTEmbed.warmConnections, {
            once: true
        });
        this.addEventListener("click", ()=>this.addIframe());
    }
    get videoId() {
        return encodeURIComponent(this.getAttribute("videoid") || "");
    }
    set videoId(id) {
        this.setAttribute("videoid", id);
    }
    get playlistId() {
        return encodeURIComponent(this.getAttribute("playlistid") || "");
    }
    set playlistId(id) {
        this.setAttribute("playlistid", id);
    }
    get videoTitle() {
        return this.getAttribute("videotitle") || "Video";
    }
    set videoTitle(title) {
        this.setAttribute("videotitle", title);
    }
    get videoPlay() {
        return this.getAttribute("videoPlay") || "Play";
    }
    set videoPlay(name) {
        this.setAttribute("videoPlay", name);
    }
    get videoStartAt() {
        return this.getAttribute("videoStartAt") || "0";
    }
    get autoLoad() {
        return this.hasAttribute("autoload");
    }
    get noCookie() {
        return this.hasAttribute("nocookie");
    }
    get posterQuality() {
        return this.getAttribute("posterquality") || "hqdefault";
    }
    get posterLoading() {
        return this.getAttribute("posterloading") || "lazy";
    }
    get params() {
        return `start=${this.videoStartAt}&${this.getAttribute("params")}`;
    }
    set params(opts) {
        this.setAttribute("params", opts);
    }
    setupDom() {
        const shadowDom = this.attachShadow({
            mode: "open"
        });
        let nonce = "";
        if (window.liteYouTubeNonce) nonce = `nonce="${window.liteYouTubeNonce}"`;
        shadowDom.innerHTML = `
      <style ${nonce}>
        :host {
          contain: content;
          display: block;
          position: relative;
          width: 100%;
          padding-bottom: calc(100% / (16 / 9));
        }

        @media (max-width: 40em) {
          :host([short]) {
            padding-bottom: calc(100% / (9 / 16));
          }
        }

        #frame, #fallbackPlaceholder, iframe {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
        }

        #frame {
          cursor: pointer;
        }

        #fallbackPlaceholder {
          object-fit: cover;
        }

        #frame::before {
          content: '';
          display: block;
          position: absolute;
          top: 0;
          background-image: linear-gradient(180deg, #111 -20%, transparent 90%);
          height: 60px;
          width: 100%;
          z-index: 1;
        }

        #playButton {
          width: 68px;
          height: 48px;
          background-color: transparent;
          background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 48"><path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z" fill="red"/><path d="M45 24 27 14v20" fill="white"/></svg>');
          z-index: 1;
          border: 0;
          border-radius: inherit;
        }

        #playButton:before {
          content: '';
          border-style: solid;
          border-width: 11px 0 11px 19px;
          border-color: transparent transparent transparent #fff;
        }

        #playButton,
        #playButton:before {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate3d(-50%, -50%, 0);
          cursor: inherit;
        }

        /* Post-click styles */
        .activated {
          cursor: unset;
        }

        #frame.activated::before,
        #frame.activated > #playButton {
          display: none;
        }
      </style>
      <div id="frame">
        <picture>
          <source id="webpPlaceholder" type="image/webp">
          <source id="jpegPlaceholder" type="image/jpeg">
          <img id="fallbackPlaceholder" referrerpolicy="origin" loading="lazy">
        </picture>
        <button id="playButton"></button>
      </div>
    `;
        this.domRefFrame = shadowDom.querySelector("#frame");
        this.domRefImg = {
            fallback: shadowDom.querySelector("#fallbackPlaceholder"),
            webp: shadowDom.querySelector("#webpPlaceholder"),
            jpeg: shadowDom.querySelector("#jpegPlaceholder")
        };
        this.domRefPlayButton = shadowDom.querySelector("#playButton");
    }
    setupComponent() {
        this.initImagePlaceholder();
        this.domRefPlayButton.setAttribute("aria-label", `${this.videoPlay}: ${this.videoTitle}`);
        this.setAttribute("title", `${this.videoPlay}: ${this.videoTitle}`);
        if (this.autoLoad || this.isYouTubeShort()) this.initIntersectionObserver();
    }
    attributeChangedCallback(name, oldVal, newVal) {
        switch(name){
            case "videoid":
            case "playlistid":
            case "videoTitle":
            case "videoPlay":
                if (oldVal !== newVal) {
                    this.setupComponent();
                    if (this.domRefFrame.classList.contains("activated")) {
                        this.domRefFrame.classList.remove("activated");
                        this.shadowRoot.querySelector("iframe").remove();
                        this.isIframeLoaded = false;
                    }
                }
                break;
            default:
                break;
        }
    }
    addIframe(isIntersectionObserver = false) {
        if (!this.isIframeLoaded) {
            let autoplay = isIntersectionObserver ? 0 : 1;
            const wantsNoCookie = this.noCookie ? "-nocookie" : "";
            let embedTarget;
            if (this.playlistId) embedTarget = `?listType=playlist&list=${this.playlistId}&`;
            else embedTarget = `${this.videoId}?`;
            if (this.isYouTubeShort()) {
                this.params = `loop=1&mute=1&modestbranding=1&playsinline=1&rel=0&enablejsapi=1&playlist=${this.videoId}`;
                autoplay = 1;
            }
            const iframeHTML = `
<iframe frameborder="0" title="${this.videoTitle}"
  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
  src="https://www.youtube${wantsNoCookie}.com/embed/${embedTarget}autoplay=${autoplay}&${this.params}"
></iframe>`;
            this.domRefFrame.insertAdjacentHTML("beforeend", iframeHTML);
            this.domRefFrame.classList.add("activated");
            this.isIframeLoaded = true;
            this.attemptShortAutoPlay();
            this.dispatchEvent(new CustomEvent("liteYoutubeIframeLoaded", {
                detail: {
                    videoId: this.videoId
                },
                bubbles: true,
                cancelable: true
            }));
        }
    }
    initImagePlaceholder() {
        const posterUrlWebp = `https://i.ytimg.com/vi_webp/${this.videoId}/${this.posterQuality}.webp`;
        const posterUrlJpeg = `https://i.ytimg.com/vi/${this.videoId}/${this.posterQuality}.jpg`;
        this.domRefImg.fallback.loading = this.posterLoading;
        this.domRefImg.webp.srcset = posterUrlWebp;
        this.domRefImg.jpeg.srcset = posterUrlJpeg;
        this.domRefImg.fallback.src = posterUrlJpeg;
        this.domRefImg.fallback.setAttribute("aria-label", `${this.videoPlay}: ${this.videoTitle}`);
        this.domRefImg?.fallback?.setAttribute("alt", `${this.videoPlay}: ${this.videoTitle}`);
    }
    initIntersectionObserver() {
        const options = {
            root: null,
            rootMargin: "0px",
            threshold: 0
        };
        const observer = new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting && !this.isIframeLoaded) {
                    $68499d7e04db319d$var$LiteYTEmbed.warmConnections();
                    this.addIframe(true);
                    observer.unobserve(this);
                }
            });
        }, options);
        observer.observe(this);
    }
    attemptShortAutoPlay() {
        if (this.isYouTubeShort()) setTimeout(()=>{
            this.shadowRoot.querySelector("iframe")?.contentWindow?.postMessage('{"event":"command","func":"' + "playVideo" + '","args":""}', "*");
        }, 2000);
    }
    isYouTubeShort() {
        return this.getAttribute("short") === "" && window.matchMedia("(max-width: 40em)").matches;
    }
    static addPrefetch(kind, url) {
        const linkElem = document.createElement("link");
        linkElem.rel = kind;
        linkElem.href = url;
        linkElem.crossOrigin = "true";
        document.head.append(linkElem);
    }
    static warmConnections() {
        if ($68499d7e04db319d$var$LiteYTEmbed.isPreconnected || window.liteYouTubeIsPreconnected) return;
        $68499d7e04db319d$var$LiteYTEmbed.addPrefetch("preconnect", "https://i.ytimg.com/");
        $68499d7e04db319d$var$LiteYTEmbed.addPrefetch("preconnect", "https://s.ytimg.com");
        $68499d7e04db319d$var$LiteYTEmbed.addPrefetch("preconnect", "https://www.youtube.com");
        $68499d7e04db319d$var$LiteYTEmbed.addPrefetch("preconnect", "https://www.google.com");
        $68499d7e04db319d$var$LiteYTEmbed.addPrefetch("preconnect", "https://googleads.g.doubleclick.net");
        $68499d7e04db319d$var$LiteYTEmbed.addPrefetch("preconnect", "https://static.doubleclick.net");
        $68499d7e04db319d$var$LiteYTEmbed.isPreconnected = true;
        window.liteYouTubeIsPreconnected = true;
    }
}
$68499d7e04db319d$var$LiteYTEmbed.isPreconnected = false;
customElements.define("lite-youtube", $68499d7e04db319d$var$LiteYTEmbed); //# sourceMappingURL=lite-youtube.js.map





var $aQpoM = parcelRequire("aQpoM");
function $e1d12b280af4d08f$var$navWatcher() {
    if ((0, $aQpoM.basePath) === "") return;
    const links = document.querySelectorAll(".INSIDE-NAV");
    links.forEach((link)=>{
        const navHref = link.attributes.href.value;
        const arrNav = navHref.split("/");
        let parsedHref = "";
        if (arrNav[0].includes(".")) {
            arrNav.shift();
            parsedHref = "/" + arrNav.join("/");
        } else parsedHref = navHref;
        link.addEventListener("click", (e)=>{
            e.preventDefault();
            const newPath = (0, $aQpoM.basePath) + parsedHref;
            document.location.href = newPath;
        });
    });
}
document.addEventListener("DOMContentLoaded", ()=>{
    $e1d12b280af4d08f$var$navWatcher();
});


console.info("%cscripts loaded", "color: green; background: lightgreen; padding: 5px 20px; border: 1px solid green;");


//# sourceMappingURL=index.09307cc1.js.map
